import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicLayoutComponent } from './layout/basic-layout.component';
import { WelcomePageComponent } from './standalone/welcome-page/welcome-page.component';

const routes: Routes = [
  // Unauthenticated (with layout component)
  { path: 'welcome', component: WelcomePageComponent },
  {
    path: '',
    component: BasicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) },
      { path: 'the-vest', loadChildren: () => import('./features/the-vest/the-vest.module').then(m => m.TheVestModule) },
      { path: 'download-our-app', loadChildren: () => import('./features/xover-trainer-ai-coach/xover-trainer-ai-coach.module').then(m => m.XoverTrainerAiCoachModule) },
      { path: 'coaching', loadChildren: () => import('./features/training/training.module').then(m => m.TrainingModule) },
      { path: 'privacy-policy', loadChildren: () => import('./features/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
      { path: 'terms-and-conditions', loadChildren: () => import('./features/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule) },
      { path: 'privacy-notice', loadChildren: () => import('./features/privacy-notice/privacy-notice.module').then(m => m.PrivacyNoticeModule) },
      { path: 'cookies-settings', loadChildren: () => import('./features/cookies-settings/cookies-settings.module').then(m => m.CookiesSettingsModule) },
      { path: 'shipping-policy', loadChildren: () => import('./features/shipping-policy/shipping-policy.module').then(m => m.ShippingPolicyModule) },
      { path: 'refund-policy', loadChildren: () => import('./features/refund-policy/refund-policy.module').then(m => m.RefundPolicyModule) },
      { path: 'refund-request', loadChildren: () => import('./features/refund-request/refund-request.module').then(m => m.RefundRequestModule) },
      { path: 'refund-status', loadChildren: () => import('./features/refund-status/refund-status.module').then(m => m.RefundStatusModule) },
      { path: 'disclaimer-safety-notice', loadChildren: () => import('./features/disclaimer-safety-notice/disclaimer-safety-notice-routing.module').then(m => m.DisclaimerSafetyNoticeRoutingModule) },
      { path: 'about', loadChildren: () => import('./features/about/about.module').then(m => m.AboutModule) },
      { path: 'contact', loadChildren: () => import('./features/contact/contact.module').then(m => m.ContactModule) },
      { path: 'testimonials', loadChildren: () => import('./features/testimonials/testimonials.module').then(m => m.TestimonialsModule) },
      { path: 'blog', loadChildren: () => import('./features/blog/blog.module').then(m => m.BlogModule) },
      { path: 'store', loadChildren: () => import('./features/store/store.module').then(m => m.StoreModule) },
      { path: 'frequently-asked-questions', loadChildren: () => import('./features/faqs/faqs.module').then(m => m.FaqsModule) },
      { path: 'request-vest-code', loadChildren: () => import('./features/request-product-code/request-product-code.module').then(m => m.RequestProductCodeModule) },
      { path: 'validate-vest-code', loadChildren: () => import('./features/request-product-code/request-product-code.module').then(m => m.RequestProductCodeModule) },
      { path: 'unsubscribe-newsletter', loadChildren: () => import('./features/unsubscribe-newsletter/unsubscribe-newsletter.module').then(m => m.UnsubscribeNewsletterModule) },
      { path: 'complete-profile', loadChildren: () => import('./features/complete-profile/complete-profile.module').then(m => m.CompleteProfileModule) },
      { path: 'invite', loadChildren: () => import('./features/invite/invite.module').then(m => m.InviteModule) },
      { path: '', redirectTo: 'home', pathMatch: 'full' }
    ]
  },
  {
    path: '**',
    component: BasicLayoutComponent,
    loadChildren: () => import('./features/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
